import { API } from '~apis/axios/instance';
import { PolicyModel } from '~models/policy';
import { ResponseBaseWithData } from '~types/response';

interface NeededAgreements {
  companyAgreements: PolicyModel.Agreement[];
  userAgreements: PolicyModel.Agreement[];
}

export default function getNeededAgreements(companyId: string, userId: string) {
  return API.get<ResponseBaseWithData<NeededAgreements>>(
    `/api/v2/companies/${companyId}/users/${userId}/need-agreements`,
  );
}
